if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			getCompositeSetWrapper() {
				return this.closest(".main-product-page[data-is-composite-set='true']")?.querySelector(
					".composite-set-picker-wrapper"
				);
			}

			getCompositeSelectionValue(componentName) {
				const compositeWrapper = this.getCompositeSetWrapper();
				if (!compositeWrapper) return "";

				const fieldsets = compositeWrapper.querySelectorAll(
					`[data-component="${componentName}"]`
				);

				return [...fieldsets]
					.map((fieldset) => fieldset.querySelector("input:checked")?.value || "")
					.filter(Boolean)
					.join(" / ");
			}

			appendCompositeSetProperties(formData) {
				const compositeWrapper = this.getCompositeSetWrapper();
				if (!compositeWrapper) return;

				const selectedColor =
					compositeWrapper.querySelector(".js-radio-colors input:checked")?.value || "";
				const selectedTop = this.getCompositeSelectionValue("top");
				const selectedBottom = this.getCompositeSelectionValue("bottom");

				if (selectedColor) formData.set("properties[Color]", selectedColor);
				if (selectedTop) formData.set("properties[Top]", selectedTop);
				if (selectedBottom) formData.set("properties[Bottom]", selectedBottom);
			}

			validateCompositeSetSelection() {
				const compositeWrapper = this.getCompositeSetWrapper();
				if (!compositeWrapper) return true;

				const selectedColor =
					compositeWrapper.querySelector(".js-radio-colors input:checked")?.value || "";
				const selectedTop = this.getCompositeSelectionValue("top");
				const selectedBottom = this.getCompositeSelectionValue("bottom");
				const topFieldsets = compositeWrapper.querySelectorAll('[data-component="top"]');
				const bottomFieldsets = compositeWrapper.querySelectorAll('[data-component="bottom"]');

				const topRequired = topFieldsets.length > 0;
				const bottomRequired = bottomFieldsets.length > 0;

				if (!selectedColor || (topRequired && !selectedTop) || (bottomRequired && !selectedBottom)) {
					this.handleErrorMessage(
						window.variantStrings?.compositeSetMissingSelection ||
							"Selecciona color, talla TOP y talla LEGGINGS."
					);
					return false;
				}

				const variantInput = this.form.querySelector('input[name="id"]');
				if (!variantInput?.value || variantInput.disabled) {
					this.handleErrorMessage(
						window.variantStrings?.compositeSetUnavailable ||
							"La combinación seleccionada no está disponible."
					);
					return false;
				}

				return true;
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				if (!this.validateCompositeSetSelection()) {
					this.submitButton.classList.remove("loading");
					return;
				}

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				this.appendCompositeSetProperties(formData);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
